import cn from 'classnames'
import React from 'react'
import ReactBottomDrawer from 'react-bottom-drawer'

interface DrawerProps {
  isVisible: boolean
  onClose: () => void
  duration?: number
  hideScrollbars?: boolean
  unmountOnExit?: boolean
  mountOnEnter?: boolean
  className?: string
  backdropClassname?: string
  children: React.ReactNode
}

const Drawer = ({ children, className, ...props }: DrawerProps) => {
  return (
    <ReactBottomDrawer className={cn(className, 'drawer')} {...props}>
      {children}
    </ReactBottomDrawer>
  )
}

export default Drawer
